// extracted by mini-css-extract-plugin
module.exports = {"progressContainer":"WorkoutProgressBar_progressContainer__1cS8M","pill":"WorkoutProgressBar_pill__2pvrh","activePill":"WorkoutProgressBar_activePill__2NOxV"};